export default function updateNewStagesCount(count) {
    return {
        type: updateNewStagesCount.type,
        payload: count,
    };
}

updateNewStagesCount.type = 'UPDATE_NEW_STAGES_COUNT';
